import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class GlobalFilterService {
  protected filters: any = {
    queryParams: {},
    requestParams: {},
  };
  constructor(protected http: HttpClient) { }
  protected widgetRefreshSubject = new Subject<string>();
  protected widgetId: string | null = null;
  protected filterSubject = new Subject<any>();
  protected currentSelectedFilter = new Subject<any>();
  protected selectedFilters: { [key: string]: any } = {};

  filter$ = this.filterSubject.asObservable();
  currentFilter$ = this.currentSelectedFilter.asObservable();
  widgetRefresh$ = this.widgetRefreshSubject.asObservable();
  activeFilter!: any;
  dropdownOptions!: { [key: string]: string[] };

  private normalizeForCompare(value: any): any {
    if (Array.isArray(value)) {
      return value
        .map((v) => this.normalizeForCompare(v))
        .sort((a, b) => JSON.stringify(a).localeCompare(JSON.stringify(b)));
    }

    if (value && typeof value === 'object') {
      return Object.keys(value)
        .sort()
        .reduce((acc: any, k: string) => {
          acc[k] = this.normalizeForCompare(value[k]);
          return acc;
        }, {});
    }

    return value;
  }

  private areValuesEqual(a: any, b: any): boolean {
    return JSON.stringify(this.normalizeForCompare(a)) === JSON.stringify(this.normalizeForCompare(b));
  }

  protected cloneValue(value: any): any {
    if (Array.isArray(value)) return value.map((v) => this.cloneValue(v));
    if (value && typeof value === 'object') return { ...value };
    return value;
  }

  isSelected(key: string, value: any): boolean {
    const stored = this.selectedFilters[key];
    if (stored === undefined || stored === null) return false;

    // Normalize both to string arrays for robust comparison (handles single value vs array mismatch)
    const valArray = (Array.isArray(value) ? value : [value]).map((v) => String(v));
    const storedArray = (Array.isArray(stored) ? stored : [stored]).map((v) => String(v));

    return this.areValuesEqual(valArray, storedArray);
  }
  updateFilterSelection(
    keyOrKeys: string | string[],
    values: any[],
    isQueryParam = false,
    widgetId?: string,
    emit: boolean = true,
    filterListener?: string | string[],
    listenerExtraParams?: { [widgetId: string]: { [key: string]: any } },
  ): void {

    console.log("lclick 30 inside updateFilterSelection", keyOrKeys, values, isQueryParam, widgetId, emit, filterListener);


    const keys = Array.isArray(keyOrKeys)
      ? keyOrKeys
      : (keyOrKeys || '')
        .split(',')
        .map((k) => k.trim())
        .filter((k) => k);

    keys.forEach((key) => {
      // console.log('[GlobalFilterService] updateFilterSelection called with:', { key, values, isQueryParam });
      console.log("lclick 31 inside updateFilterSelection chart-filter-handler filterKeys.forEach loop", key, values, isQueryParam);
      const valueToStore = this.cloneValue(values);
      this.selectedFilters[key] = valueToStore;

      if (isQueryParam) {
        this.filters.queryParams[key] = this.cloneValue(values);
        console.log("lclick 33 inside updateFilterSelection chart-filter-handler filterKeys.forEach loop if block", this.filters.queryParams);
      } else {
        console.log("lclick 32 inside updateFilterSelection chart-filter-handler filterKeys.forEach loop else block", this.filters.requestParams);
        this.filters.requestParams[key] = this.cloneValue(values);
      }
    });
    console.log("lclick 34 inside updateFilterSelection chart-filter-handler after filterKeys.forEach loop");
    this.widgetId = widgetId || null;
    if (emit) {
      const filterData = {
        ...this.filters,
        widgetId: this.widgetId,
        changedFilterKey: keys.length === 1 ? keys[0] : keys,
        filterListener,
        ...(listenerExtraParams ? { listenerExtraParams } : {}),
      };
      // console.log('[GlobalFilterService] Emitting filter data:', filterData);
      console.log('lclick 35 inside updateFilterSelection chart-filter-handler after filterKeys.forEach loop if block', filterData);

      this.filterSubject.next(filterData);
      console.log('lclick 36 inside updateFilterSelection chart-filter-handler after filterKeys.forEach loop if block', filterData);
      this.currentSelectedFilter.next({ key: keys });
      console.log('lclick 37 inside updateFilterSelection chart-filter-handler after filterKeys.forEach loop if block', filterData);
    }
    // console.log('lclick 38 inside updateFilterSelection chart-filter-handler after filterKeys.forEach loop if block', filterData);
  }

  requestWidgetRefresh(widgetId: string): void {
    this.widgetRefreshSubject.next(widgetId);
  }

  resetFilterSelection(
    key: string,
    isQueryParam = false,
    filterListener?: string | string[],
  ): void {
    console.log('inside resetFilterSelection', key, isQueryParam);
    delete this.selectedFilters[key];
    if (isQueryParam) {
      delete this.filters.queryParams[key];
    } else {
      delete this.filters.requestParams[key];
    }
    // Reset widgetId so this deselection is treated as a global filter change.
    // If widgetId were preserved from the last legend click, shouldReload() would
    // return false for all charts and the deselection would be silently ignored.
    this.widgetId = null;
    // Forward filterListener so only targeted charts reload (not ALL charts)
    this.filterSubject.next({
      ...this.filters,
      widgetId: null,
      ...(filterListener ? { filterListener } : {}),
    });
  }

  deleteKey(key: string, isQueryParam = false): void {
    console.log('inside deleteKey', key, isQueryParam);
    delete this.selectedFilters[key];
    if (isQueryParam) {
      delete this.filters.queryParams[key];
    } else {
      delete this.filters.requestParams[key];
    }
  }

  getCurrentFilters(): any {
    console.log('inside getcurrentFilters', this.filters);
    return this.filters;
  }
  updateAllFilters(newFilters: any): void {
    console.log('inside updateAllFilters', newFilters);
    this.filters = newFilters;
    this.selectedFilters = {};
    this.filterSubject.next(this.filters);
    this.currentSelectedFilter.next({});
  }

  clearAllFilters() {
    console.log('inside clearAllFilters');
    this.filters = {
      queryParams: {},
      requestParams: {},
    };
    this.selectedFilters = {};
    this.filterSubject.next({
      ...this.filters,
      widgetId: null,
      changedFilterKey: null,
    });
    this.currentSelectedFilter.next('');
  }

  emitCurrentFilters(): void {
    this.filterSubject.next({
      ...this.filters,
      widgetId: null,
    });
  }

  initialTrigger() {
    console.log('inside initialTrigger');
    // skipReload: true tells charts NOT to fire an API call for this emission.
    // Charts already load themselves via ngAfterViewInit — this trigger is only
    // for filter dropdowns to populate, not for charts to reload.
    this.filterSubject.next({
      queryParams: {},
      requestParams: {},
      widgetId: null,
      skipReload: true,
    });
  }
  downloadExcel(apiUrl: string, filterPayload: any): Observable<Blob> {
    console.log('inside downloadExcel', apiUrl, filterPayload);
    return this.http.post(apiUrl, filterPayload, {
      responseType: 'blob',
      withCredentials: false, // 👈 STOPS interceptor from reading undefined cookie
    });
  }

  buildPayload(config: any, filters: any[]): any {
    console.log('inside buildPayload before if ', config, filters);
    if (config?.skipDefaultPayload) {
      // If customPayload is explicitly true, or missing/null/undefined, return empty object.
      // Otherwise, return the customPayload object itself.
      console.log('inside buildPayload  in if ', config, filters);
      return config?.customPayload === true ? {} : config?.customPayload || {};
    }

    return {
      requestData: {
        filters: filters,
      },
      responseList: [],
      entity: config?.entity || 'default_entity',
      workflowId: config?.workflowId || 'default_workflow',
      endpoints: [
        {
          functionName: config?.functionName || 'DefaultService',
          version: config?.version || '1.0',
        },
      ],
      communicationType: 'rest',
      version: config?.version || '1.0',
    };
  }
}
